import React from 'react';

import './index.less';

export const MoneyBackGuarantee: React.SFC<{ message: string }> = ({ message }) => (
	<div className="MoneyBackGuarantee">
		<div className="MoneyBackGuarantee__description">{message}</div>
	</div>
);
